import {
    ACCEPTED_ZAJAVL_STATUS,
    ACCEPTED_ZAJAVL_WITH_CONFIRMED_CONSENT_STATUS,
    ACCEPTED_ZAJAVL_WITH_CONFIRMED_DENIAL_STATUS,
    ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS,
    ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS,
    ACCEPTED_ZAJAVL_WITH_DROP_CONSENT_STATUS_HIDDEN,
    ACCEPTED_ZAJAVL_WITH_DROP_DENIAL_STATUS_HIDDEN,
    APPLICANT_CALL_OFF_STATUS,
    MODERATION_ZAJAVL_STATUS,
    NOT_SENT_ZAJAVL_STATUS,
    RETURN_REWORK_ZAJAVL_STATUS,
    VUZ_REJECTED_STATUS,
    VUZ_DELETE_STATUS,
    VUZ_TAKE_CHANGES_AFTER_ACCEPTED_HIDDEN,
    VUZ_DROP_CHANGES_AFTER_ACCEPTED_HIDDEN,
    SEND_CHANGES_AFTER_ACCEPTED,
} from '@assets/js/constants/statusOnlineZajavl';

export const configStatuses = {
    [NOT_SENT_ZAJAVL_STATUS]: 'Создано (не отправлено)',
    [MODERATION_ZAJAVL_STATUS]: 'Отправлено. На модерации',
    [RETURN_REWORK_ZAJAVL_STATUS]: 'Есть замечания. Возвращено на доработку',
    [ACCEPTED_ZAJAVL_STATUS]: 'Принято приемной комиссией',
    [VUZ_REJECTED_STATUS]: 'Отклонено приемной комиссией',
    [APPLICANT_CALL_OFF_STATUS]: 'Отказ абитуриента',
    [ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS]: 'Отправлено согласие на зачисление',
    [ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS]: 'Отправлен отказ от зачисления',
    [ACCEPTED_ZAJAVL_WITH_CONFIRMED_CONSENT_STATUS]: 'Принято согласие на зачисление',
    [ACCEPTED_ZAJAVL_WITH_CONFIRMED_DENIAL_STATUS]: 'Принят отказ от зачисления',
    [SEND_CHANGES_AFTER_ACCEPTED]: 'Отправлены изменения',

    [VUZ_TAKE_CHANGES_AFTER_ACCEPTED_HIDDEN]: 'Отправленные изменения приняты приемной комиссией',
    [VUZ_DROP_CHANGES_AFTER_ACCEPTED_HIDDEN]: 'Отправленные изменения не были приняты приемной комиссией',

    [ACCEPTED_ZAJAVL_WITH_DROP_CONSENT_STATUS_HIDDEN]: 'Заявление о согласии на зачисление не было принято приемной комиссией',
    [ACCEPTED_ZAJAVL_WITH_DROP_DENIAL_STATUS_HIDDEN]: 'Заявление об отказе от зачисления не было принято приемной комиссией',

    [VUZ_DELETE_STATUS]: 'Удалено членом приемной комиссии',
};

export const configStatusesTranslateMap = {
    [NOT_SENT_ZAJAVL_STATUS]: 'zajavl_statuses.not_sent',
    [MODERATION_ZAJAVL_STATUS]: 'zajavl_statuses.moderation',
    [RETURN_REWORK_ZAJAVL_STATUS]: 'zajavl_statuses.returned_for_revision',
    [ACCEPTED_ZAJAVL_STATUS]: 'zajavl_statuses.accepted_by_admissions',
    [VUZ_REJECTED_STATUS]: 'zajavl_statuses.rejected_by_admissions',
    [APPLICANT_CALL_OFF_STATUS]: 'zajavl_statuses.applicant_withdrew',
    [ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS]: 'zajavl_statuses.enrollment_consent_sent',
    [ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS]: 'zajavl_statuses.enrollment_denial_sent',
    [ACCEPTED_ZAJAVL_WITH_CONFIRMED_CONSENT_STATUS]: 'zajavl_statuses.enrollment_consent_confirmed',
    [ACCEPTED_ZAJAVL_WITH_CONFIRMED_DENIAL_STATUS]: 'zajavl_statuses.enrollment_denial_confirmed',
    [SEND_CHANGES_AFTER_ACCEPTED]: 'zajavl_statuses.changes_sent_after_acceptance',

    [VUZ_TAKE_CHANGES_AFTER_ACCEPTED_HIDDEN]: 'zajavl_statuses.changes_accepted_by_admissions_hidden',
    [VUZ_DROP_CHANGES_AFTER_ACCEPTED_HIDDEN]: 'zajavl_statuses.changes_rejected_by_admissions_hidden',

    [ACCEPTED_ZAJAVL_WITH_DROP_CONSENT_STATUS_HIDDEN]: 'zajavl_statuses.enrollment_consent_rejected_hidden',
    [ACCEPTED_ZAJAVL_WITH_DROP_DENIAL_STATUS_HIDDEN]: 'zajavl_statuses.enrollment_denial_rejected_hidden',

    [VUZ_DELETE_STATUS]: 'zajavl_statuses.deleted_by_admissions',
};